import { useLang } from "@/context/LanguageContext";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { NALJURI_PHOTOS } from "@/lib/photos";

export default function Experiences() {
  const { t, lang } = useLang();
  const items = t.experiences.items;

  // Three alphas — all real Naljuri photographs
  const alphas = [
    { key: "sadapathor",   img: NALJURI_PHOTOS.SADAPATHOR },
    { key: "jaflong_stone",img: NALJURI_PHOTOS.NALJURI_JHEEREE }, // Jaflong-area river/stones (real)
    { key: "cricket",      img: NALJURI_PHOTOS.VIRAL_CRICKET },
  ];
  // Supporting (real photographs)
  const supporting = [
    { key: "jharna", img: NALJURI_PHOTOS.NALJURI_JHARNA },
    { key: "shapla", img: NALJURI_PHOTOS.SHAPLA },
  ];

  return (
    <section id="experiences" className="bg-cream-100" data-testid="experiences-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-6">
            <p className="eyebrow tag-line">{t.experiences.eyebrow}</p>
            <h2 className={`mt-4 text-4xl md:text-5xl font-display text-forest-700 tracking-tight leading-[1.05] ${lang==='bn'?'font-bn':''}`}
                data-testid="experiences-title">
              {t.experiences.title}
            </h2>
            <div className="gold-rule mt-6" />
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <p className="text-base text-slate-warm leading-relaxed">{t.experiences.sub}</p>
          </div>
        </div>

        {/* Three Alphas */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          {alphas.map((a, i) => {
            const it = items[a.key];
            return (
              <a key={a.key} href={a.key === 'cricket' ? '#cricket' : '#booking'}
                 data-testid={`experience-card-${a.key}`}
                 className="group relative overflow-hidden rounded-md border border-forest-100 h-[460px]">
                <img src={a.img} alt={it.title} loading="lazy"
                     className="w-full h-full object-cover img-zoom" />
                <div className="absolute inset-0 bg-gradient-to-t from-forest-900/95 via-forest-900/45 to-forest-900/10" />
                <div className="absolute top-4 left-4 inline-flex items-center gap-2 bg-gold-600/95 text-cream-100 px-3 py-1.5 rounded-full">
                  <Sparkles className="w-3 h-3" />
                  <span className="text-[10px] uppercase tracking-widest2">Alpha {String(i+1).padStart(2,'0')}</span>
                </div>
                <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end">
                  <h3 className={`text-2xl md:text-3xl font-display text-cream-100 leading-tight ${lang==='bn'?'font-bn':''}`}>{it.title}</h3>
                  <p className="mt-2 text-sm text-cream-100/85 max-w-md">{it.desc}</p>
                  <div className="mt-5 inline-flex items-center gap-1.5 text-xs text-gold-400">
                    Plan this experience
                    <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:rotate-45" />
                  </div>
                </div>
              </a>
            );
          })}
        </div>

        {/* Supporting two */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {supporting.map((s) => {
            const it = items[s.key];
            return (
              <a key={s.key} href="#booking"
                 data-testid={`experience-card-${s.key}`}
                 className="group relative overflow-hidden rounded-md border border-forest-100 h-[280px]">
                <img src={s.img} alt={it.title} loading="lazy"
                     className="w-full h-full object-cover img-zoom" />
                <div className="absolute inset-0 bg-gradient-to-t from-forest-900/85 via-forest-900/20 to-transparent" />
                <div className="absolute inset-0 p-6 md:p-8 flex items-end justify-between gap-4">
                  <div>
                    <h3 className={`text-2xl font-display text-cream-100 leading-tight ${lang==='bn'?'font-bn':''}`}>{it.title}</h3>
                    <p className="mt-1 text-sm text-cream-100/85">{it.desc}</p>
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-gold-400 shrink-0 transition-transform group-hover:rotate-45" />
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
